export default {
  title: 'Mobile app',
  scanDescription: 'Scan the code to get Macro on your phone.',
  storeLinksDescription: 'Download Macro from your app store.',
  appStoreDescription: 'Download Macro from the App Store.',
  googlePlayDescription: 'Download Macro from Google Play.',
  phone: 'Phone',
  appStorePrompt: 'Download Macro on the App Store',
  googlePlayPrompt: 'Get Macro on Google Play',
  copyLink: 'Copy link',
  copyStoreLink: 'Copy {{store}} link',
};
